var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOtpsuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 95,
  height: 95,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#91C653",
  d: "M71.23 29.406a3.57 3.57 0 0 1 .01 5.05L41.147 64.673a3.57 3.57 0 0 1-5.05.01L25.121 53.753a3.572 3.572 0 0 1 5.04-5.061l8.444 8.41L66.18 29.415a3.57 3.57 0 0 1 5.05-.01"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#77AD39",
  d: "M47.792 7.192c-18.931 0-34.813 13.219-38.89 30.928a40 40 0 0 0-1.015 8.977c0 22.022 17.883 39.905 39.905 39.905s39.905-17.883 39.905-39.905S69.814 7.192 47.792 7.192M1.942 36.517C6.746 15.64 25.457.05 47.791.05c25.967 0 47.048 21.08 47.048 47.048 0 25.967-21.08 47.048-47.048 47.048C21.825 94.145.744 73.064.744 47.097c0-3.634.414-7.176 1.197-10.58"
}))));
export { SvgOtpsuccess as ReactComponent };
export default __webpack_public_path__ + "db3b531f3c8dc856866428fe3874a13c.svg";